// extracted by mini-css-extract-plugin
export default {"container":"Cards_container__QX4cf","col":"Cards_col__7VAxv"};